import React from "react"
import avatar from "avatar/maya-sad.svg"

const MayaSad = (props) => <img src={avatar} className="avatar" {...props} />

export default MayaSad
